var _defs, _path, _polyline, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRelatorios = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #171954;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-4 {\n        stroke-width: 2.2px;\n      }\n\n      .cls-2 {\n        stroke-width: 1.97px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke-width: 2.23px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m56.55,61.91H18.45V13.09h25.63c4.06,4.5,8.11,9.01,12.17,13.51.1,11.77.2,23.55.3,35.32Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "43.65 13.83 43.65 27.46 55.57 27.46"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.17,
    y1: 33.69,
    x2: 51.83,
    y2: 33.69
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.17,
    y1: 42.88,
    x2: 51.83,
    y2: 42.88
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.17,
    y1: 24.1,
    x2: 43.13,
    y2: 24.1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRelatorios);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RELATORIOS.7f17da2c8ffb87f4622fd0fe8e5cd805.svg";